export default "__VITE_ASSET__CoH7Nf33__"